import { render } from "./CoberturaPage.vue?vue&type=template&id=bb0945a6&scoped=true"
import script from "./CoberturaPage.vue?vue&type=script&lang=js"
export * from "./CoberturaPage.vue?vue&type=script&lang=js"

import "./CoberturaPage.vue?vue&type=style&index=0&id=bb0945a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0945a6"]])

export default __exports__